import React, { useState, useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { pathOr, valuesIn } from "ramda";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Checkbox,Chip, Menu, Typography, MenuItem, Button, useTheme, Grid, Backdrop } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { options } from "./listview-options";
import { formatDate } from "../../common/utils";
import NumberFormat from 'react-number-format';
import SkeletonShell from "../../components/Skeleton/index";
import Customer360 from "./components/Customer360";
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";
import {Tooltip,IconButton} from "@material-ui/core"
import FileViewerComp from "../FileViewer/FileViewer";
import { FaIcon } from "..";
const ListView = ({
  ACLAccess,
  dataLabels,
  data,
  module,
  moduleLabel,
  isLoading,
  changePageOrSort,
  onDelete,
  onEdit,
  meta,
  listViewWhere,
  page,
  dateFormat,
  sortOrder,
  sortBy,
  rowsPerPage,
  lastListViewSort
}) => {

  // let customer360Button = {
  // 'label': "Preview",
  // 'name': "360",
  // "type":'varchar'
 
  
  // };

  const [previewFile, setPreviewFile] = useState({open:false,filename:"",filepath:""});
  
  const classes = useStyles();
  const {  link } = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedRecord, setSelectedRecords] = useState([]);
  const [selectedRecordIndex, setSelectedRecordIndexes] = useState([]);
  const [where, setFilterQuery] = useState(listViewWhere);
  const [selectAll, setSelectAll] = useState(false);
  const [emailModal, setEmailModal] = useState({visible:false});
  const [open, setOpen] = useState(false);
  const [customer360Id, setCustomer360Id] = useState(null);
  const currentTheme = useTheme();
  const [selectedRecordLength, setselectedRecordLength] = useState(selectAll ? "All " : selectedRecord.length)
  const config = useSelector((state) => state.config);
  const site_url = pathOr("",["config", "site_url"],config);
  const c360Modules = pathOr("",["config", "c360Modules"],config);
  const statusBackground = pathOr([],["config", "fields_background", module],config);
  const currencyId = pathOr([], ['userPreference','attributes', 'global', 'currency'], config);
  const currencyArray = pathOr([], ['userPreference','attributes', 'CurrenciesRecords'], config);
  

  let currencySymbol = '₹';
  currencyArray.map((item) => {
    // console.log("Currency Id = ",item);
    if(item.id == currencyId)
    {
      currencySymbol = item.symbol;
    }
    });
  // console.log("Currency Id = ",currencyId);
  let statusField = Object.keys(statusBackground);
  useEffect(() => {
    setSelectAll(false)
    setselectedRecordLength(selectAll ? "All " : selectedRecord.length)
    setSelectedRecords([])
    setSelectedRecordIndexes([])
    setEmailModal({visible:false,to:'',parent_name:{parent_name:'',parent_type:'',parent_id:''}});
    // if(dataLabels.some(item => "360" !== item.name)){
    //   dataLabels.push(customer360Button);
    //   console.log("dataLabels",dataLabels)
    // }
    
  
  }, [module]);

  useEffect(() => {
    if (selectedRecordLength === 0) {
      setSelectAll(false)
    }
  }, [selectedRecordLength])
  useEffect(() => {
    setselectedRecordLength(selectAll ? "All " : selectedRecord.length);
    
  }, [selectedRecord]);

  useEffect(() => {
    setFilterQuery(where)
  }, [where]);

  function truncate(str,n) {
    return str?.length > n ? str.substr(0,n-1) + "..." : str;
  }
const open360 =(id) =>{
  alert(id)
}
const handleClickOpen = (cid) => {
  setOpen(true);
  setCustomer360Id(cid);
};


  const  handleShowPreviewFile = (fname,url) =>{
    let arr = fname.split(".");
    let ext = arr[arr.length-1].toUpperCase();
    setPreviewFile({open:true,filename:fname,filepath:url,filetype:ext});
  }
  const handleSelectAllChange = (event) => {
    const selectedRecordsId = [];
    const selectedRecordsIndex = [];

    setSelectAll(event.target.checked);
    event.target.checked && data.forEach((feed, i) => {
      selectedRecordsId.push(data.id);
      selectedRecordsIndex.push(i)
    })

    setSelectedRecords(selectedRecordsId)
    setSelectedRecordIndexes(selectedRecordsIndex)
    setselectedRecordLength(selectAll ? "All " : selectedRecord.length)
  };
  const handleCheck = (val) => {
    return data.some(item => val === item.id);
  }
  const handleSelectChange = (currentRowsSelected = null, allRowsSelected = null, rowsSelected = null) => {
    setSelectAll(false);
    if (currentRowsSelected.length === 0) {
      data.forEach((feed, i) => {
        var indexselectedRecord = selectedRecord.indexOf(feed.id)
        var indexselectedIndex = selectedRecordIndex.indexOf(i)
        if (indexselectedRecord !== -1) {
          selectedRecord.splice(indexselectedRecord, 1);
        }
        if (indexselectedIndex !== -1) {
          selectedRecordIndex.splice(indexselectedIndex, 1);
        }
      })
    } else {
      currentRowsSelected.forEach((feed, i) => {
        if (selectedRecord.some(item => data[feed.index].id === item)) {
          var indexselectedRecord = selectedRecord.indexOf(data[feed.index].id)
          var indexselectedIndex = selectedRecordIndex.indexOf(feed.index)
          if (indexselectedRecord !== -1) {
            selectedRecord.splice(indexselectedRecord, 1);
          }
          if (indexselectedIndex !== -1) {
            selectedRecordIndex.splice(indexselectedIndex, 1);
          }
        } else {
          selectedRecord.push(data[feed.index].id);
          selectedRecordIndex.push(feed.index)
        }
      });
    }
    // console.log(selectedRecord)
    // console.log(selectedRecordIndex)
    setselectedRecordLength(selectAll ? "All " : selectedRecord.length)
    // setSelectedRecords(selectedRecordsId)
    // setSelectedRecordIndexes(selectedRecordsIndex)
  }

  useEffect(
    () => {
      const selectedRecordsIndex = [];
      if (selectAll) {
        selectAll && data.forEach((feed, i) => {
          selectedRecordsIndex.push(i)
        })
      } else {
        selectedRecord && data.forEach((feed, i) => {
          if (selectedRecord && selectedRecord.some(item => feed.id === item)) {
            selectedRecordsIndex.push(i)
          }
        });
      }
      setSelectedRecordIndexes([...new Set(selectedRecordsIndex)])
    },
    [data]
  );

  const handleClick = (event, dataIndex) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(dataIndex);

  };


  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const renderPopOver = (dataIndex, rowIndex) => {
    let editAcl = pathOr(0, ['attributes','ACLAccess', 'edit'], data[selectedIndex]);
    let deletAcl = pathOr(0, ['attributes','ACLAccess', 'delete'], data[selectedIndex]);
  
    return (
      <div key={dataIndex + rowIndex}>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(e) => handleClick(e, dataIndex)}
          style={{ margin: 0, minWidth: "auto" }}

        >
          <FaIcon icon="fas fa-cog" size="1x" />
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          variant="menu"
          elevation={1}
        >
          <MenuItem className={classes.fontSizeCstm} disabled={editAcl===0} onClick={() => onEdit(data[selectedIndex].id)}>Edit</MenuItem>
          <MenuItem className={classes.fontSizeCstm}
          disabled={deletAcl===0}
            onClick={() => {
              const recordId = data[selectedIndex].id;
              handleClose();
              onDelete(recordId);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
        {
          c360Modules.includes(module)?(
          <IconButton aria-label="preview" size="small" onClick={(e) => handleClickOpen(data[dataIndex])} >
            <VisibilityIcon />
           </IconButton>):""
        }              
      </div>
    );
  };




  const getFilteredDataLabels = () => {
    return [
      {
        name: selectedRecordLength > 0 ?"":"Action",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRenderLite: (dataIndex, rowIndex) => (
            selectedRecordLength > 0 ?null: <div>{renderPopOver(dataIndex, rowIndex)}</div>
          ),
        },
      },
      ...dataLabels
        .filter((it) => it.name)
        .map((dl) => {

          if (statusField && statusField.length > 0 && statusField.some(item => dl.name === item)) {
            return {
              ...dl,
              options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {

                  let option = (dl.options) ? Object.keys(dl.options).find(key => dl.options[key] === value) : '';
                  let optionBgColor = `${pathOr("", [dl.name, option, "background_color"], statusBackground)}`;
                  let statusStyle = {};

                  if (currentTheme.palette.type === 'dark') {
                    statusStyle = { color: optionBgColor, fontWeight: 'bolder', background: 'transparent', border: '1px solid' };

                  } else {
                    statusStyle = { color: optionBgColor, background: optionBgColor + "20", border: 'none', };
                  }
                  return (
                    value && optionBgColor ? <Chip size="small" className={classes.statusBg} style={statusStyle} label={value} /> : value
                  )
                }
              }
            }
          }

          if ((dl.name === "name" || dl.name === "full_name" || dl.name === "first_name" || dl.name === "last_name" || dl.name === 'document_name')) {
            return {
              ...dl,
              options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const id = data[tableMeta["rowIndex"]].id;
                  let emailUrl ='';
                  if(module==="Emails"){
                    const msgno = data[tableMeta["rowIndex"]]['attributes'].msgno;
                    const uid = data[tableMeta["rowIndex"]]['attributes'].uid;
                    emailUrl = `/${msgno}/${uid}`;
                  }
                  if((pathOr("",[tableMeta["rowIndex"],"attributes","ACLAccess","view"],data)===0 && module !== 'AOR_Reports') || ((ACLAccess.view && ACLAccess.view===0) && module === 'AOR_Reports')){
                  //if((data[tableMeta["rowIndex"]]['attributes']['ACLAccess'].view==0)){
                    return (
                      <Typography>
                        {value}
                      </Typography>
                    );
                  }
                  else
                  {
                    return (
                      <Typography>
                        <Link
                          to={`/app/detailview/${module}/${id}${emailUrl}`}
                          className={link}
                          // component="button"
                          variant="body2"
                        >
                          {value}
                        </Link>
                      </Typography>
                    );
                  }
                },
              },
            };
          }
          // else if(dl.name==='360'){
          //   return {
          //     ...dl,
          //     options: {
          //       customBodyRenderLite: (dataIndex, rowIndex) => (
          //         <Button
          //           variant="outlined"
          //           onClick={() => open360(data[dataIndex].id)}
          //         >
          //           360 Preview
          //         </Button>
          //       ),
          //     },
          //   };
          // }
          else if (dl.name === "email1" || dl.name==="email2" || dl.type === "email") {
            return {
              ...dl,
              options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const id = pathOr("",[tableMeta["rowIndex"],"id"],data);
                  const name = pathOr("",[tableMeta["rowIndex"],"attributes","name"],data);
                  // console.log("list view name",name);
                  return (
                    <Typography>
                      <Link
                        to="#"
                        className={link}
                        //component="button"
                        onClick={(e)=>{e.preventDefault(); setEmailModal({visible:true,to:value,parent_name:{parent_name:name,parent_type:module,parent_id:id}})}}
                        variant="body2"
                      >
                        {value}
                      </Link>
                    </Typography>
                  );
                },
              },
            };
          }
          else if (dl.type === "parent") {
            return {
              ...dl,
              options: {
                filter: false,
                sort:false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const parent_id = data[tableMeta["rowIndex"]].attributes.parent_id;
                  const parent_type = data[tableMeta["rowIndex"]].attributes.parent_type;
                  
                  return (
                    <Typography>
                      <Link
                        to={`/app/detailview/${parent_type}/${parent_id}`}
                        className={link}
                        // component="button"
                        variant="body2"
                      >
                        {value}
                      </Link>
                    </Typography>
                  );
                },
              },
            };
          }
          else if (dl.type === "relate") {
            return {
              ...dl,
              options: {
                filter: false,
                
                customBodyRender: (value, tableMeta, updateValue) => {
                  const ss = dl.id_name;
                  
                  const parent_id = pathOr("",[tableMeta["rowIndex"],'attributes',ss],data);
                  const parent_type = dl.module;
                  
                  return (
                    <Typography>
                      <Link
                        to={`/app/detailview/${parent_type}/${parent_id}`}
                        className={link}
                        // component="button"
                        variant="body2"
                      >
                        {value}
                      </Link>
                    </Typography>
                  );
                },
              },
            };
          }
          else if (
            dl.type === "date" ||
            dl.type === "datetime" ||
            dl.type === "datetimecombo"
          ) {
            return {
              ...dl,
              options: {
                customBodyRender: (value, tableMeta, updateValue) =>
                  formatDate(value, dateFormat),
              },
            };
          }
          else if (
            dl.type === "currency" 
            // || dl.type === "decimal"
          ) {
            return {
              ...dl,
              options: {
                customBodyRender: (value, tableMeta, updateValue) =>{
                return (
                  <Typography variant="body2">
                   {currencySymbol} <NumberFormat value={value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} />
                    </Typography>
                );
                
                },
              },
            };
          } else if (dl.name === "action_c") {
            return {
              ...dl,
              options: {
                customBodyRenderLite: (dataIndex, rowIndex) => (
                  <Button
                    variant="outlined"
                    onClick={() => onEdit(data[dataIndex].id)}
                  >
                    edit
                  </Button>
                ),
              },
            };
          }
          else if (dl.type === "bool") {
            return {
              ...dl,
              options: {
                customBodyRender: (value, tableMeta, updateValue) =>{
                  console.log("boool",value);
                return (
                  <Checkbox
                  disabled
                  checked={value}
                  color="primary"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
                );
                
                },
              },
            };

          } else if (dl.type === "file") {
            return {
              ...dl,
              options: {
                filter: false,
                sort:false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  //const moduleName = module==='Notes'?'Notes':'Documents';
                  const moduleName = module;
                  let fname = data[tableMeta["rowIndex"]]['attributes'].filename;
                  let furl = `${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=${moduleName}`;
                  return (
                    <Typography>
                      { (moduleName=="Documents" || moduleName=="Notes") && fname ? 
                            <VisibilityIcon fontSize='small' style={{margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"}} onClick={()=> handleShowPreviewFile(fname,furl)}>
                            </VisibilityIcon >  
                           :
                      ""}
                      <Tooltip title={data[tableMeta["rowIndex"]]['attributes'].filename} >
                      <Link
                        to={`#`}
                        className={link}
                        // component="button"
                        onClick={()=>{saveAs(`${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=${moduleName}`, data[tableMeta["rowIndex"]]['attributes'].filename);
	                      toast("Downloading in progress!");}}
                        variant="body2"                        
                      >
                        {/* style={{alignItems:"center",marginLeft:"1vw"}} */}
                        {moduleName==="Notes" ? truncate(value,17) : truncate(value,17)}
                      </Link>
                      </Tooltip>
                    </Typography>
                  );
                },
              },
            };
          }else {
            return dl;
          }
        }),
    ];
  };

  
  const getFilteredData = () => data.map((item) => {
    const lead_scoring_c = pathOr(null,["attributes","lead_scoring_c"],item);
    const opportunities_scoring_c = pathOr(null,["attributes","opportunities_scoring_c"],item);
    //for lead score
    if (lead_scoring_c && lead_scoring_c != null && typeof lead_scoring_c == 'string') {
      let tmp = document.createElement("SPAN");
      tmp.innerHTML = item.attributes.lead_scoring_c;
      item.attributes.lead_scoring_c = tmp.textContent || tmp.innerText || "";
      //item.attributes.lead_scoring_c = <Chip variant="primary" size="small" label={tmp.textContent || tmp.innerText || ""} />;
    }
    if (opportunities_scoring_c && opportunities_scoring_c != null && typeof opportunities_scoring_c == 'string') {
      let tmp = document.createElement("SPAN");
      tmp.innerHTML = item.attributes.opportunities_scoring_c;
      item.attributes.opportunities_scoring_c = tmp.textContent || tmp.innerText || "";
      //item.attributes.opportunities_scoring_c = <Chip variant="primary" size="small" label={tmp.textContent || tmp.innerText || ""} />;
    }
    return item.attributes;
  });
  return (
    //ternary condition added by Deep on 11-02-2021 for skeleton

    <>
      <Backdrop className={classes.backdrop} open={isLoading}>
        {/* <CircularProgress color="inherit" />  */}
        <SkeletonShell layout='listView' display />
      </Backdrop>
      {/* <Box display={isLoading?'block':'none'}>
<SkeletonShell layout='listView' display /> 
</Box> */}
      {/* <Box display={!isLoading?'block':'none'}> */}
      <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
        <Grid container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={0}
          className={classes.brandLogoBar}
        >
          <Grid item>
            <Typography component={'span'} variant="subtitle2" className={classes.brandLogoTitle} >
              {moduleLabel}
            </Typography>

          </Grid>
          <Grid item style={{ marginTop: "3px" }}>
            {/*<BrandLogo />*/}
          </Grid>
        </Grid>

        <MUIDataTable
          title={<Typography component={'span'} variant="subtitle1">
            {/* <FormControlLabel
                control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
                label="Select All"
                style={{ 'margin-left': '-20px' }}
              /> */}

            {/* {selectedRecordLength > 0 ? " " + selectedRecordLength + " rows(s) selected   " : moduleLabel} */}
            {selectedRecordLength > 0 ? " " + selectedRecordLength + " rows(s) selected   " : null}
            {/* {isLoading && <CircularProgress size={24} className={spinner} />} */}

          </Typography>}
          data={getFilteredData()}
          columns= {data.length > 0 ? getFilteredDataLabels() : []}
          options={options(meta, page, changePageOrSort, isLoading, handleSelectChange, selectedRecordIndex, selectAll, handleSelectAllChange, selectedRecord, selectedRecordLength, setSelectedRecords, setSelectedRecordIndexes, setselectedRecordLength, where, setSelectAll,emailModal, ACLAccess,sortBy,sortOrder,rowsPerPage,lastListViewSort)}
          download={false}
          className={classes.listDataTable}
          
        />
        {(previewFile.open) ? 
        <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
        {customer360Id && open?<Customer360 relData={customer360Id} open={open} setOpen={setOpen} setCustomer360Id={setCustomer360Id}/>:null}
      </MuiThemeProvider>
      {/* </Box> */}
    </>

  );
};

export default memo(ListView);
